import axios from 'axios';
import apiroutes from '@/API/ApiRoutes';


const state = {};

const getters = {};

const actions = {

  GetRequestFeedList({commit}, payload) {

    return new Promise((resolve, reject) => {
      let tok = '';
      let auth = JSON.parse(localStorage.getItem('auth-response'));
      if (auth){
        tok= 'Bearer '+auth.access_token;
      }else{
        tok= '';
      }

      let authheader = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        Authorization : tok
      };

      axios.get(apiroutes.routes.requestFeedList, {headers: authheader})
        .then((response) => {
          console.log("request feed list working")
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
